export const COMMENT_TYPES = {
  DEFAULT: 'default',
  AUDIT: 'audit',
};
